exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._29nyZ4KidIJk11t-3Gg_-c{font-weight:300;font-size:14px;font-weight:400;color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] ._29nyZ4KidIJk11t-3Gg_-c{margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"header": "_29nyZ4KidIJk11t-3Gg_-c"
};